import React from 'react';
import './PricingPage.css';
import { CheckCircle } from 'lucide-react';

function PricingPage({ onPayNow, hasSubscribed }) {
  return (
    <div className="pricing-container">
      <div className="pricing-card">
        <h2>Exclusive Access</h2>
        <p className="subtitle">Unlock the full potential of our marketplace</p>

        <div className="price">
          <span className="currency">$</span>
          <span className="amount">9</span>
          <span className="cents">.99</span>
        </div>
        <p className="price-subtitle">One-time payment</p>

        <ul className="features">
          <li><CheckCircle size={16} /> Unlimited access to the marketplace</li>
          <li><CheckCircle size={16} /> List and sell your products</li>
          <li><CheckCircle size={16} /> Priority customer support</li>
          <li><CheckCircle size={16} /> Exclusive member events</li>
        </ul>

        {hasSubscribed ? (
          <div className="subscribed-message">
            <CheckCircle size={20} />
            <span>You're Subscribed!</span>
          </div>
        ) : (
          <button onClick={onPayNow} className="get-started-btn">
            Subscribe Now
          </button>
        )}
      </div>
    </div>
  );
}

export default PricingPage;